// extracted by mini-css-extract-plugin
export default {"modal":"Beyim_modal__gPEjL","modalWrapper":"Beyim_modalWrapper__0aNbJ"};